import { Flex, Span } from "@goodfill/ui-components";
import { API } from "aws-amplify";
import { useState, useCallback, useEffect } from "react";
import { toast } from "react-hot-toast";
import { TradeHistoryTable } from "./TradeHistoryTable";
import { useRecoilValue } from "recoil";
import { pricedBondState, userDataState } from "../../../../state";
import { doPortfolioCustomTradeTicketList } from "../../../backendApi/amplifyGraphQl/PortfolioCustomTradeTicketList/doPortfolioCustomTradeTicketList";
import { PortfolioTradeTicket } from "../../../backendApi/amplifyGraphQl/PortfolioCustomTradeTicketList/PortfolioTradeTicket";
import { PresentedTradeTicket } from "./PresentedTradeTicket";
import { mapPortfolioTradeTicketToPresentedTradeTicket } from "./mapPortfolioTradeTicketToPresentedTradeTicket";
import { Intent, ProgressBar } from "@blueprintjs/core";

export const TradeHistorySection = () => {
  const userData = useRecoilValue(userDataState);

  const accountId = userData?.account.id;
  const [isLoading, setIsLoading] = useState(false);
  const pricedBonds = useRecoilValue(pricedBondState);
  const [tradeTickets, setTradeTickets] = useState<PortfolioTradeTicket[]>([]);

  const init = useCallback(async () => {
    if (!accountId) return;

    try {
      setIsLoading(true);
      const result = await doPortfolioCustomTradeTicketList(API, accountId);
      setTradeTickets(result);
    } catch (e) {
      console.error(e);
      toast.error(`Loading Trade Tickets failed ${e}`);
    } finally {
      setIsLoading(false);
    }
  }, [accountId]);

  useEffect(() => {
    init();
  }, [init]);

  const rows = tradeTickets.reduce<PresentedTradeTicket[]>((acc, tradeTicket) => {
    const bond = pricedBonds.get(tradeTicket.orderTicket.bondId);
    if (bond != null) {
      acc.push(mapPortfolioTradeTicketToPresentedTradeTicket(tradeTicket, bond));
    }

    return acc;
  }, []);

  if (userData === null) {
    return null;
  }

  return (
    <Flex direction="col" verticalMargin={2} horizontalMargin={8} horizontalPadding={8} gap={0} width="w-full">
      <Flex direction="row" items="center" justify="between" verticalMargin={4}>
        <Span font="semibold" size="lg">
          Trade
        </Span>
      </Flex>

      {isLoading ? <ProgressBar intent={Intent.PRIMARY} /> : <div className="h-[8px]" />}

      <TradeHistoryTable tradeTickets={rows} />
    </Flex>
  );
};
